import type { JSONSchema7 } from "json-schema";
import type { MCPServer } from "@/schemas/agent.schema";
import { api } from "@/services/api";

export const mcpApi = {
  async listTools(server: MCPServer) {
    const { data } = await api.post(`/mcp/list-tools`, server);

    return data as {
      name: string;
      description?: string;
      inputSchema: JSONSchema7;
    }[];
  },
};
